"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20 12V6H4v12h10v2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6zm-1 2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m-4.34-.34c.39-.39.39-1.02 0-1.41l-2.12-2.12 1.27-1.27c.31-.32.09-.86-.36-.86H9.5c-.28 0-.5.22-.5.5v3.95c0 .45.54.67.85.35l1.27-1.27 2.12 2.12c.39.4 1.03.4 1.42.01"
}), 'PinEndRounded');